module.exports = {"652327100":"吉木萨尔镇","652327101":"三台镇","652327102":"泉子街镇","652327103":"北庭镇","652327104":"二工镇","652327105":"大有镇","652327202":"庆阳湖乡","652327203":"老台乡","652327205":"新地乡","652327400":"五彩湾工业园区","652327500":"兵团农六师红旗农场"}


//////////////////
// WEBPACK FOOTER
// ./src/town/652327.json
// module id = 3076
// module chunks = 0